import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CasinoRootComponent from './CasinoRootComponent';
import useGlobalState from './GlobalStateContext';
import Header from './Header';
import { IS_CASINO_ENABLED } from './helpers/Constants';
import { PERMISSION, ROLE } from './helpers/Permissions';
import ProtectedRoute from './helpers/ProtectedRoute';
import AdminActivityLogs from './pages/admin/AdminActivityLogs';
import AdminCreate from './pages/admin/AdminCreate';
import AdminEdit from './pages/admin/AdminEdit';
import AdminPage from './pages/admin/AdminPage';
import AdminShow from './pages/admin/AdminShow';
import AffiliateCreate from './pages/affiliate/AffiliateCreate';
import AffiliateEdit from './pages/affiliate/AffiliateEdit';
import AffiliatePage from './pages/affiliate/AffiliatePage';
import AffiliateShow from './pages/affiliate/AffiliateShow';
import AffiliateOwnerCreate from './pages/affiliateOwner/AffiliateOwnerCreate';
import AffiliateOwnerEdit from './pages/affiliateOwner/AffiliateOwnerEdit';
import AffiliateOwnerPage from './pages/affiliateOwner/AffiliateOwnerPage';
import AffiliateOwnerShow from './pages/affiliateOwner/AffiliateOwnerShow';
import ArticlesList from './pages/article/ArticlesList';
import CreateArticle from './pages/article/CreateArticle';
import EditArticle from './pages/article/EditArticle';
import SingleArticle from './pages/article/SingleArticle';
import AttachAdmin from './pages/attach/AttachAdmin';
import AttachPermission from './pages/attach/AttachPermission';
import AttachRole from './pages/attach/AttachRole';
import Login from './pages/auth/LoginForm';
import BlockedCountriesList from './pages/blockedCountries/BlockedCountriesList';
import BlockedCountyCreate from './pages/blockedCountries/BlockedCountyCreate';
import CustomBoxList from './pages/customBoxes/CustomBoxList';
import CustomBoxUpdate from './pages/customBoxes/CustomBoxUpdate';
import CreateCustomRedirect from './pages/customRedirects/CreateCustomRedirect';
import CustomRedirectsList from './pages/customRedirects/CustomRedirectsList';
import EditCustomRedirect from './pages/customRedirects/EditCustomRedirect';
import SingleCustomRedirect from './pages/customRedirects/SingleCustomRedirect';
import Dashboard from './pages/dashboard/Dashboard';
import DepositPage from './pages/deposit/DepositPage';
import DepositShow from './pages/deposit/DepositShow';
import DrawShow from './pages/draw/DrawShow';
import AddFaqToCategory from './pages/faq/AddFaqToCategory';
import CreateFaq from './pages/faq/CreateFaq';
import CreateFaqCategory from './pages/faq/CreateFaqCategory';
import EditFaq from './pages/faq/EditFaq';
import EditFaqCategory from './pages/faq/EditFaqCategory';
import FaqCategoryList from './pages/faq/FaqCategoryList';
import FaqList from './pages/faq/FaqList';
import SingleFaq from './pages/faq/SingleFaq';
import SingleFaqCategory from './pages/faq/SingleFaqCategory';
import FileManager from './pages/fileManager/FileManager';
import LotteriesList from './pages/lottery/LotteriesList';
import LotteryRuleTierShow from './pages/lottery/LotteryRuleTierShow';
import LotteryShow from './pages/lottery/LotteryShow';
import MasterAffiliateAgentCreate from './pages/masterAffiliateAgent/MasterAffiliateAgentCreate';
import MasterAffiliateAgentEdit from './pages/masterAffiliateAgent/MasterAffiliateAgentEdit';
import MasterAffiliateAgentPage from './pages/masterAffiliateAgent/MasterAffiliateAgentPage';
import MasterAffiliateAgentShow from './pages/masterAffiliateAgent/MasterAffiliateAgentShow';
import MasterAgentCreate from './pages/masterAgent/MasterAgentCreate';
import MasterAgentEdit from './pages/masterAgent/MasterAgentEdit';
import MasterAgentPage from './pages/masterAgent/MasterAgentPage';
import MasterAgentShow from './pages/masterAgent/MasterAgentShow';
import MenuCreate from './pages/menus/MenuCreate';
import MenuDetails from './pages/menus/MenuDetails';
import MenuItemCreate from './pages/menus/MenuItemCreate';
import MenuItemDetails from './pages/menus/MenuItemDetails';
import MenuItemUpdate from './pages/menus/MenuItemUpdate';
import MenuList from './pages/menus/MenuList';
import MenuUpdate from './pages/menus/MenuUpdate';
import MissingTranslationsArticlesList from './pages/missingTranslations/articles/MissingTranslationsArticlesList';
import CreateNews from './pages/news/CreateNews';
import EditNews from './pages/news/EditNews';
import NewsList from './pages/news/NewsList';
import SingleNews from './pages/news/SingleNews';
import NotificationCreate from './pages/notifications/NotificationCreate';
import NotificationDetails from './pages/notifications/NotificationDetails';
import NotificationList from './pages/notifications/NotificationList';
import NotificationUpdate from './pages/notifications/NotificationUpdate';
import BlogSetting from './pages/pageSettings/Blog/BlogSetting';
import NewsSetting from './pages/pageSettings/News/NewsSetting';
import PageSettingsList from './pages/pageSettings/PageSettingsList';
import PaymentMethodChannelCreate from './pages/paymentMethodChannel/PaymentMethodChannelCreate';
import PaymentMethodChannelEdit from './pages/paymentMethodChannel/PaymentMethodChannelEdit';
import PaymentMethodChannelPage from './pages/paymentMethodChannel/PaymentMethodChannelPage';
import PaymentMethodChannelShow from './pages/paymentMethodChannel/PaymentMethodChannelShow';
import PaymentMethodCreate from './pages/paymentMethods/PaymentMethodCreate';
import PaymentMethodEdit from './pages/paymentMethods/PaymentMethodEdit';
import PaymentMethodShow from './pages/paymentMethods/PaymentMethodShow';
import PaymentMethodsList from './pages/paymentMethods/PaymentMethodsList';
import PermissionShow from './pages/permissions/PermissionShow';
import PermissionsList from './pages/permissions/PermissionsList';
import PostbackCreate from './pages/postback/PostbackCreate';
import PostbackEdit from './pages/postback/PostbackEdit';
import PostbackShow from './pages/postback/PostbackShow';
import PostbacksList from './pages/postback/PostbacksList';
import EditProfile from './pages/profile/EditProfile';
import PromoCodeCampaigns from './pages/promoCodes/PromoCodeCampaigns';
import PromoCodeCreate from './pages/promoCodes/PromoCodeCreate';
import PromoCodeEdit from './pages/promoCodes/PromoCodeEdit';
import PromoCodeShow from './pages/promoCodes/PromoCodeShow';
import ResellerApplicantsList from './pages/reseller/ResellerApplicantsList';
import ResellerCreate from './pages/reseller/ResellerCreate';
import ResellerEdit from './pages/reseller/ResellerEdit';
import ResellerShow from './pages/reseller/ResellerShow';
import ResellersPage from './pages/reseller/ResellersPage';
import RoleEdit from './pages/roles/RoleEdit';
import RoleShow from './pages/roles/RoleShow';
import RolesList from './pages/roles/RolesList';
import SeoTagCreate from './pages/seoTag/SeoTagCreate';
import SeoTagEdit from './pages/seoTag/SeoTagEdit';
import SeoTagList from './pages/seoTag/SeoTagList';
import SeoTagShow from './pages/seoTag/SeoTagShow';
import SliderItemCreate from './pages/sliders/SliderItemCreate';
import SliderItemEdit from './pages/sliders/SliderItemEdit';
import SliderList from './pages/sliders/SliderList';
import SliderShow from './pages/sliders/SliderShow';
import SubAffiliateCreate from './pages/subaffiliate/SubAffiliateCreate';
import SubAffiliateEdit from './pages/subaffiliate/SubAffiliateEdit';
import SubAffiliatePage from './pages/subaffiliate/SubAffiliatePage';
import SubAffiliateShow from './pages/subaffiliate/SubAffiliateShow';
import SuperAgentCreate from './pages/superAgent/SuperAgentCreate';
import SuperAgentEdit from './pages/superAgent/SuperAgentEdit';
import SuperAgentPage from './pages/superAgent/SuperAgentPage';
import SuperAgentShow from './pages/superAgent/SuperAgentShow';
import TicketPage from './pages/ticket/TicketPage';
import TicketShow from './pages/ticket/TicketShow';
import TicketScratchcardsPage from './pages/ticket/scratchcards/TicketsScratchcardsPage';
import TicketUserView from './pages/ticket/userView/TicketUserView';
import TicketMultiDrawPage from './pages/ticketMultidraw/TicketMultiDrawPage';
import UserCreate from './pages/user/UserCreate';
import UserEdit from './pages/user/UserEdit';
import UserShow from './pages/user/UserShow';
import UsersPage from './pages/user/UsersPage';
import VouchersPage from './pages/vouchers/VouchersPage';
import WithdrawalPage from './pages/withdrawal/WithdrawalPage';
import WithdrawalShow from './pages/withdrawal/WithdrawalShow';
import WithdrawalMethodCreate from './pages/withdrawalMethods/WithdrawalMethodCreate';
import WithdrawalMethodEdit from './pages/withdrawalMethods/WithdrawalMethodEdit';
import WithdrawalMethodShow from './pages/withdrawalMethods/WithdrawalMethodShow';
import WithdrawalMethodsList from './pages/withdrawalMethods/WithdrawalMethodsList';
import { ROLES } from './services/AdminPolicyService';
import UserLootboxesPage from "./pages/lootbox/userLootboxes/UserLootboxesPage";
import LootboxItemsPage from "./pages/lootbox/lootboxItems/LootboxItemsPage";
import LootboxPage from "./pages/lootbox/lootbox/LootboxPage";
import LootboxDetailsPage from "./pages/lootbox/lootbox/LootboxDetailsPage";
import LootboxItemDetailsPage from "./pages/lootbox/lootboxItems/LootboxItemDetailsPage";
import LootboxPoolsPage from "./pages/lootbox/lootboxPools/LootboxPoolsPage";
import LootboxPoolDetailsPage from "./pages/lootbox/lootboxPools/LootboxPoolDetailsPage";
import UserLootboxDetailsPage from "./pages/lootbox/userLootboxes/UserLootboxDetailsPage";

export default function AppRootComponent() {
    const loaded = !!useGlobalState().loggedAdmin;

    return (
        <>
            <Header />
            <Route exact path="/login">
                <Login />
            </Route>
            {loaded && (
                <>
                    <Switch>
                        <ProtectedRoute key="dashboard" exact path="/" pageName="Dashboard">
                            <Dashboard />
                        </ProtectedRoute>
                        <ProtectedRoute key="profile" exact path="/profile" pageName="Edit profile">
                            <EditProfile />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="admins"
                            exact
                            path="/admins"
                            pageName="Admins"
                            permissions={[PERMISSION.VIEW_ADMIN]}
                        >
                            <AdminPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="super-admins"
                            exact
                            path="/super-admins"
                            pageName="Admins"
                            permissions={[PERMISSION.VIEW_ADMIN]}
                        >
                            <AdminPage onlySuperadmins />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="admin-create"
                            exact
                            path="/admins/create"
                            pageName="Create Admin"
                            permissions={[PERMISSION.CREATE_ADMIN]}
                        >
                            <AdminCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="admin"
                            exact
                            path="/admins/:id"
                            pageName="Admin"
                            permissions={[PERMISSION.VIEW_ADMIN]}
                        >
                            <AdminShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="admin-edit"
                            exact
                            path="/admins/:id/edit"
                            pageName="Edit Admin"
                            permissions={[PERMISSION.UPDATE_ADMIN]}
                        >
                            <AdminEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="admin-activity-logs"
                            exact
                            path="/admin-activity-logs"
                            pageName="Admin activity logs"
                            permissions={[PERMISSION.VIEW_DATABASE_LOGS]}
                            roles={ROLES.SUPER_ADMINS}
                        >
                            <AdminActivityLogs />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="users"
                            exact
                            path="/users"
                            pageName="Users"
                            permissions={[PERMISSION.VIEW_USER]}
                        >
                            <UsersPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="create-user"
                            exact
                            path="/users/create"
                            pageName="Create user"
                            permissions={[PERMISSION.CREATE_USER]}
                        >
                            <UserCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="user"
                            exact
                            path="/users/:id"
                            pageName="User"
                            permissions={[PERMISSION.VIEW_USER]}
                            roles={[ROLE.AFFILIATE_OWNER]}
                        >
                            <UserShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="update-user"
                            exact
                            path="/users/:id/edit"
                            pageName="Update user"
                            permissions={[PERMISSION.UPDATE_USER]}
                        >
                            <UserEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment_method"
                            exact
                            path="/payment_methods"
                            permissions={[PERMISSION.VIEW_PAYMENT_METHOD]}
                        >
                            <PaymentMethodsList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment_method"
                            exact
                            path="/payment_methods/create"
                            permissions={[PERMISSION.CREATE_PAYMENT_METHOD]}
                        >
                            <PaymentMethodCreate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment_method"
                            exact
                            path="/payment_methods/:id"
                            permissions={[PERMISSION.VIEW_PAYMENT_METHOD]}
                        >
                            <PaymentMethodShow />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment_method"
                            exact
                            path="/payment_methods/:id/edit"
                            permissions={[PERMISSION.UPDATE_PAYMENT_METHOD]}
                        >
                            <PaymentMethodEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="resellers"
                            exact
                            path="/resellers"
                            pageName="Resellers"
                            permissions={[PERMISSION.VIEW_RESELLER]}
                        >
                            <ResellersPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="reseller-applications"
                            exact
                            path="/resellers/applications"
                            pageName="Reseller Applications"
                            permissions={[PERMISSION.VIEW_RESELLER_APPLICANT]}
                        >
                            <ResellerApplicantsList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="reseller-create"
                            exact
                            path="/resellers/create"
                            pageName="Create Reseller"
                            permissions={[PERMISSION.CREATE_USER, PERMISSION.CREATE_RESELLER]}
                        >
                            <ResellerCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="reseller"
                            exact
                            path="/resellers/:id"
                            pageName="Reseller"
                            permissions={[PERMISSION.VIEW_RESELLER]}
                        >
                            <ResellerShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="reseller"
                            exact
                            path="/resellers/:id/edit"
                            pageName="Update Reseller"
                            permissions={[PERMISSION.UPDATE_RESELLER]}
                        >
                            <ResellerEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="tickets"
                            exact
                            path="/tickets"
                            pageName="Tickets"
                            permissions={[PERMISSION.VIEW_TICKET]}
                        >
                            <TicketPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="ticket"
                            exact
                            path="/tickets/:id"
                            pageName="Ticket"
                            permissions={[PERMISSION.VIEW_TICKET]}
                        >
                            <TicketShow />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="ticket-user"
                            exact
                            path="/tickets/user_view/:id"
                            permissions={[PERMISSION.VIEW_TICKET]}
                        >
                            <TicketUserView />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="tickets-multi-draw"
                            exact
                            path="/tickets_multi_draw"
                            pageName="MultiDraw Tickets"
                            permissions={[PERMISSION.VIEW_TICKET]}
                        >
                            <TicketMultiDrawPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="tickets-scratchcards"
                            exact
                            path="/tickets_scratchcards"
                            pageName="Scratchcards Tickets"
                            permissions={[PERMISSION.VIEW_SCRATCHCARDS_TICKET]}
                        >
                            <TicketScratchcardsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox_tickets"
                            exact
                            path="/lootbox_tickets"
                            pageName="Lootbox Tickets"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <UserLootboxesPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox_ticket"
                            exact
                            path="/lootbox_tickets/:id"
                            pageName="Lootbox Ticket"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <UserLootboxDetailsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootboxes"
                            exact
                            path="/lootboxes"
                            pageName="Lootboxes"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <LootboxPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox"
                            exact
                            path="/lootboxes/:id"
                            pageName="Lootbox"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <LootboxDetailsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox_rewards"
                            exact
                            path="/lootbox_rewards"
                            pageName="Lootbox Rewards"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <LootboxItemsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox_reward"
                            exact
                            path="/lootbox_rewards/:id"
                            pageName="Lootbox Reward"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <LootboxItemDetailsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox_pools"
                            exact
                            path="/lootbox_pools"
                            pageName="Lootbox Pools"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <LootboxPoolsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="lootbox_pool"
                            exact
                            path="/lootbox_pools/:id"
                            pageName="Lootbox Pool"
                            permissions={[PERMISSION.VIEW_LOOTBOX]}
                        >
                            <LootboxPoolDetailsPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="page-settings"
                            exact
                            path="/page-settings"
                            pageName="Page settings"
                            permissions={[PERMISSION.VIEW_PAGE_SETTINGS]}
                        >
                            <PageSettingsList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="page-settings"
                            exact
                            path="/page-settings/blog_image_visible"
                            pageName="Setting blog"
                            permissions={[PERMISSION.VIEW_PAGE_SETTINGS]}
                        >
                            <BlogSetting />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="page-settings"
                            exact
                            path="/page-settings/news_image_visible"
                            pageName="Setting news"
                            permissions={[PERMISSION.VIEW_PAGE_SETTINGS]}
                        >
                            <NewsSetting />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="custom_box"
                            exact
                            path="/custom_box"
                            pageName="Custom Box"
                            permissions={[PERMISSION.VIEW_CUSTOM_BOX]}
                        >
                            <CustomBoxList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="custom_box_update"
                            exact
                            path="/custom_box/:id?"
                            pageName="Custom Box Update"
                            permissions={[PERMISSION.UPDATE_CUSTOM_BOX]}
                        >
                            <CustomBoxUpdate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="articles"
                            exact
                            path="/articles"
                            pageName="Articles"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <ArticlesList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="articles-partials"
                            exact
                            path="/articles/partials"
                            pageName="Articles"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <ArticlesList partials />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="article"
                            exact
                            path="/articles/create/:partial?"
                            pageName="Create Article"
                            permissions={[PERMISSION.CREATE_ARTICLE]}
                        >
                            <CreateArticle />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="article"
                            exact
                            path="/articles/:id/edit"
                            pageName="Edit Article"
                            permissions={[PERMISSION.UPDATE_ARTICLE]}
                        >
                            <EditArticle />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="article"
                            exact
                            path="/articles/:id"
                            pageName="Show Article"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <SingleArticle />
                        </ProtectedRoute>

                        <ProtectedRoute key="faq" exact path="/faq" pageName="FAQ" permissions={[PERMISSION.VIEW_FAQ]}>
                            <FaqList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq-agents"
                            exact
                            path="/faq/agents"
                            pageName="FAQ Agents"
                            permissions={['view faq']}
                        >
                            <FaqList agents />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq"
                            exact
                            path="/faq/create"
                            pageName="Create FAQ"
                            permissions={[PERMISSION.CREATE_FAQ]}
                        >
                            <CreateFaq />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq"
                            exact
                            path="/faq/:id/edit"
                            pageName="Edit FAQ"
                            permissions={[PERMISSION.UPDATE_FAQ]}
                        >
                            <EditFaq />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq"
                            exact
                            path="/faq/:id"
                            pageName="Show FAQ"
                            permissions={[PERMISSION.VIEW_FAQ]}
                        >
                            <SingleFaq />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq-category"
                            exact
                            path="/faq_category"
                            pageName="FAQ Category"
                            permissions={[PERMISSION.VIEW_FAQ_CATEGORY]}
                        >
                            <FaqCategoryList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq-category"
                            exact
                            path="/faq_category/create"
                            pageName="Create FAQ Category"
                            permissions={[PERMISSION.CREATE_FAQ_CATEGORY]}
                        >
                            <CreateFaqCategory />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq-category"
                            exact
                            path="/faq_category/:id/edit"
                            pageName="Edit FAQ Category"
                            permissions={[PERMISSION.UPDATE_FAQ_CATEGORY]}
                        >
                            <EditFaqCategory />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq-category"
                            exact
                            path="/faq_category/:id/add_faq"
                            pageName="Add FAQ to Category"
                            permissions={[PERMISSION.UPDATE_FAQ_CATEGORY]}
                        >
                            <AddFaqToCategory />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="faq-category"
                            exact
                            path="/faq_category/:id"
                            pageName="Show FAQ Category"
                            permissions={[PERMISSION.VIEW_FAQ_CATEGORY]}
                        >
                            <SingleFaqCategory />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="news"
                            exact
                            path="/news"
                            pageName="News"
                            permissions={[PERMISSION.VIEW_NEWS]}
                        >
                            <NewsList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="news"
                            exact
                            path="/news/create"
                            pageName="Create News"
                            permissions={[PERMISSION.CREATE_NEWS]}
                        >
                            <CreateNews />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="news"
                            exact
                            path="/news/:id/edit"
                            pageName="Edit News"
                            permissions={[PERMISSION.UPDATE_NEWS]}
                        >
                            <EditNews />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="news"
                            exact
                            path="/news/:id"
                            pageName="Show News"
                            permissions={[PERMISSION.VIEW_NEWS]}
                        >
                            <SingleNews />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="affiliates"
                            exact
                            path="/affiliates"
                            pageName="Affiliates"
                            permissions={[PERMISSION.VIEW_AFFILIATE]}
                        >
                            <AffiliatePage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate"
                            exact
                            path="/affiliates/create"
                            pageName="Create Affiliate"
                            permissions={[PERMISSION.CREATE_AFFILIATE]}
                        >
                            <AffiliateCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-edit"
                            exact
                            path="/affiliates/:id/edit"
                            pageName="Edit Affiliate"
                            permissions={[PERMISSION.UPDATE_AFFILIATE]}
                        >
                            <AffiliateEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-view"
                            exact
                            path="/affiliates/:id"
                            pageName="Affiliate"
                            permissions={[PERMISSION.VIEW_AFFILIATE]}
                        >
                            <AffiliateShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="sub-affiliates"
                            exact
                            path="/sub-affiliates"
                            pageName="Sub Affiliates"
                            permissions={[PERMISSION.VIEW_SUB_AFFILIATE]}
                        >
                            <SubAffiliatePage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="sub-affiliate-create"
                            exact
                            path="/sub-affiliates/create"
                            pageName="Create Sub Affiliate"
                            permissions={[PERMISSION.CREATE_SUB_AFFILIATE]}
                        >
                            <SubAffiliateCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="sub-affiliate-edit"
                            exact
                            path="/sub-affiliates/:id/edit"
                            pageName="Edit Sub Affiliate"
                            permissions={[PERMISSION.UPDATE_SUB_AFFILIATE]}
                        >
                            <SubAffiliateEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="sub-affiliate-view"
                            exact
                            path="/sub-affiliates/:id"
                            pageName="SubAffiliate"
                            permissions={[PERMISSION.VIEW_SUB_AFFILIATE]}
                        >
                            <SubAffiliateShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="permissions"
                            exact
                            path="/permissions"
                            pageName="Permissions"
                            permissions={[PERMISSION.VIEW_PERMISSION]}
                        >
                            <PermissionsList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="permission"
                            exact
                            path="/permissions/:id"
                            pageName="Permission"
                            permissions={[PERMISSION.VIEW_PERMISSION]}
                        >
                            <PermissionShow />
                        </ProtectedRoute>
                        <ProtectedRoute key="attach-role" exact path="/:root/:id/attach/role" pageName="Attach Role">
                            <AttachRole />
                        </ProtectedRoute>
                        <ProtectedRoute key="attach-admin" exact path="/:root/:id/attach/admin" pageName="Attach Admin">
                            <AttachAdmin />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="attach-permission"
                            exact
                            path="/:root/:id/attach/permission"
                            pageName="Attach Permission"
                        >
                            <AttachPermission />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="roles"
                            exact
                            path="/roles"
                            pageName="Roles"
                            permissions={[PERMISSION.VIEW_ROLE]}
                        >
                            <RolesList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="role"
                            exact
                            path="/roles/:id"
                            pageName="Role"
                            permissions={[PERMISSION.VIEW_ROLE]}
                        >
                            <RoleShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="role-edit"
                            exact
                            path="/roles/:id/edit"
                            pageName="Edit Role"
                            permissions={[PERMISSION.UPDATE_ROLE]}
                        >
                            <RoleEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="postbacks"
                            exact
                            path="/postbacks"
                            pageName="Postbacks"
                            permissions={[PERMISSION.VIEW_POSTBACK]}
                        >
                            <PostbacksList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="postback-create"
                            exact
                            path="/postbacks/create"
                            pageName="Create Postback"
                            permissions={[PERMISSION.CREATE_POSTBACK]}
                        >
                            <PostbackCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="postback"
                            exact
                            path="/postbacks/:id"
                            pageName="Postback"
                            permissions={[PERMISSION.VIEW_POSTBACK]}
                        >
                            <PostbackShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="postback-edit"
                            exact
                            path="/postbacks/:id/edit"
                            pageName="Edit Postback"
                            permissions={[PERMISSION.UPDATE_POSTBACK]}
                        >
                            <PostbackEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="lotteries"
                            exact
                            path="/lotteries"
                            pageName="Lotteries"
                            permissions={[PERMISSION.VIEW_LOTTERY]}
                        >
                            <LotteriesList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="lottery"
                            exact
                            path="/lotteries/:slug"
                            pageName="Lottery"
                            permissions={[PERMISSION.VIEW_LOTTERY]}
                        >
                            <LotteryShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="lottery"
                            exact
                            path="/lotteries/:slug/rule_tiers/:id"
                            pageName="Tier"
                            permissions={[PERMISSION.VIEW_LOTTERY]}
                        >
                            <LotteryRuleTierShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="draw"
                            exact
                            path="/lotteries/:slug/draws/:draw_no"
                            pageName="Draw"
                            permissions={[PERMISSION.VIEW_DRAW]}
                        >
                            <DrawShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="deposits"
                            exact
                            path="/deposits"
                            pageName="Deposits"
                            permissions={[PERMISSION.VIEW_DEPOSIT]}
                        >
                            <DepositPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="deposit"
                            exact
                            path="/deposits/:id"
                            pageName="Deposit"
                            permissions={[PERMISSION.VIEW_DEPOSIT]}
                        >
                            <DepositShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="super-agents"
                            exact
                            path="/super_agents"
                            pageName="Super Agents"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AGENT]}
                        >
                            <SuperAgentPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="super-agent-create"
                            exact
                            path="/super_agents/create"
                            pageName="Create Super Agent"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AGENT]}
                        >
                            <SuperAgentCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="super-agent"
                            exact
                            path="/super_agents/:id"
                            pageName="Super Agent"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AGENT]}
                        >
                            <SuperAgentShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="super-agent-edit"
                            exact
                            path="/super_agents/:id/edit"
                            pageName="Edit Super Agent"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AGENT]}
                        >
                            <SuperAgentEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="withdrawals"
                            exact
                            path="/withdrawals"
                            pageName="Withdrawals"
                            permissions={[PERMISSION.VIEW_WITHDRAWAL]}
                        >
                            <WithdrawalPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="withdrawal"
                            exact
                            path="/withdrawals/:id"
                            pageName="Withdrawal"
                            permissions={[PERMISSION.VIEW_WITHDRAWAL]}
                        >
                            <WithdrawalShow />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="withdrawal_method"
                            exact
                            path="/withdrawal_methods"
                            permissions={[PERMISSION.VIEW_WITHDRAWAL_METHOD]}
                        >
                            <WithdrawalMethodsList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="withdrawal_method"
                            exact
                            path="/withdrawal_methods/create"
                            permissions={[PERMISSION.CREATE_WITHDRAWAL_METHOD]}
                        >
                            <WithdrawalMethodCreate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="withdrawal_method"
                            exact
                            path="/withdrawal_methods/:id"
                            permissions={[PERMISSION.VIEW_WITHDRAWAL_METHOD]}
                        >
                            <WithdrawalMethodShow />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="withdrawal_method"
                            exact
                            path="/withdrawal_methods/:id/edit"
                            permissions={[PERMISSION.UPDATE_WITHDRAWAL_METHOD]}
                        >
                            <WithdrawalMethodEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="promo-codes"
                            exact
                            path="/promo_codes"
                            pageName="Promo Codes"
                            permissions={[PERMISSION.VIEW_PROMO_CODE]}
                        >
                            <PromoCodeCampaigns />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="promo-code-create"
                            exact
                            path="/promo_codes/create"
                            pageName="Add Promo Code"
                            permissions={[PERMISSION.CREATE_PROMO_CODE]}
                        >
                            <PromoCodeCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="promo-code"
                            exact
                            path="/promo_codes/:id"
                            pageName="Promo Code"
                            permissions={[PERMISSION.VIEW_PROMO_CODE]}
                        >
                            <PromoCodeShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="promo-code-edit"
                            exact
                            path="/promo_codes/:id/edit"
                            pageName="Edit Promo Code"
                            permissions={[PERMISSION.UPDATE_PROMO_CODE]}
                        >
                            <PromoCodeEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-owners"
                            exact
                            path="/affiliate_owners"
                            pageName="Affiliate Owners"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AFFILIATE_AGENT]}
                        >
                            <AffiliateOwnerPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-owner-create"
                            exact
                            path="/affiliate_owners/create"
                            pageName="Create Affiliate Owner"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AFFILIATE_AGENT]}
                        >
                            <AffiliateOwnerCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-owner"
                            exact
                            path="/affiliate_owners/:id"
                            pageName="Affiliate Owner"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AFFILIATE_AGENT]}
                        >
                            <AffiliateOwnerShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-owner-edit"
                            exact
                            path="/affiliate_owners/:id/edit"
                            pageName="Edit Affiliate Owner"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AFFILIATE_AGENT]}
                        >
                            <AffiliateOwnerEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="affiliate-owner-create-affiliate"
                            exact
                            path="/affiliate_owners/:adminId/create-affiliate"
                            pageName="Add new Affiliate"
                            roles={[...ROLES.MAIN_ADMINS, ROLE.MASTER_AFFILIATE_AGENT]}
                        >
                            <AffiliateCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="vouchers"
                            exact
                            path="/vouchers"
                            pageName="Vouchers list"
                            permissions={[PERMISSION.VIEW_VOUCHER]}
                        >
                            <VouchersPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="menus"
                            exact
                            path="/menus"
                            pageName="Menus"
                            permissions={[PERMISSION.VIEW_MENU]}
                        >
                            <MenuList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="menu-create"
                            exact
                            path="/menus/create"
                            pageName="Create Menu"
                            permissions={[PERMISSION.CREATE_MENU]}
                        >
                            <MenuCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="menu"
                            exact
                            path="/menus/:id"
                            pageName="Menu"
                            permissions={[PERMISSION.VIEW_MENU]}
                        >
                            <MenuDetails />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="menu-update"
                            exact
                            path="/menus/:id/update"
                            pageName="Update Menu"
                            permissions={[PERMISSION.UPDATE_MENU]}
                        >
                            <MenuUpdate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="menu_item-create"
                            exact
                            path="/menu_items/create/:menuId"
                            pageName="Create Menu Item"
                            permissions={[PERMISSION.CREATE_MENU_ITEM]}
                        >
                            <MenuItemCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="menu_item"
                            exact
                            path="/menu_items/:id"
                            pageName="Menu Item Details"
                            permissions={[PERMISSION.VIEW_MENU_ITEM]}
                        >
                            <MenuItemDetails />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="menu_item-update"
                            exact
                            path="/menu_items/:id/update"
                            pageName="Update Menu Item"
                            permissions={[PERMISSION.UPDATE_MENU_ITEM]}
                        >
                            <MenuItemUpdate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="master-affiliate-agents"
                            exact
                            path="/master_affiliate_agents"
                            pageName="Master Affiliate Agents"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAffiliateAgentPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-affiliate-agent-create"
                            exact
                            path="/master_affiliate_agents/create"
                            pageName="Create Master Affiliate Agent"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAffiliateAgentCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-affiliate-agent"
                            exact
                            path="/master_affiliate_agents/:id"
                            pageName="Master Affiliate Agent"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAffiliateAgentShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-affiliate-agent-edit"
                            exact
                            path="/master_affiliate_agents/:id/edit"
                            pageName="Edit Master Affiliate Agent"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAffiliateAgentEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-agents"
                            exact
                            path="/master_agents"
                            pageName="Master Agents"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAgentPage />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-agent-create"
                            exact
                            path="/master_agents/create"
                            pageName="Create Master Agent"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAgentCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-agent"
                            exact
                            path="/master_agents/:id"
                            pageName="Master Agent"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAgentShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="master-agent-edit"
                            exact
                            path="/master_agents/:id/edit"
                            pageName="Edit Master Agent"
                            roles={ROLES.MAIN_ADMINS}
                        >
                            <MasterAgentEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="notifications"
                            exact
                            path="/notifications"
                            pageName="Notifications"
                            permissions={[PERMISSION.VIEW_MANUAL_NOTIFICATION]}
                        >
                            <NotificationList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="notification-create"
                            exact
                            path="/notifications/create"
                            pageName="Create Notification"
                            permissions={[PERMISSION.CREATE_MANUAL_NOTIFICATION]}
                        >
                            <NotificationCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="notification"
                            exact
                            path="/notifications/:id"
                            pageName="Notification"
                            permissions={[PERMISSION.VIEW_MANUAL_NOTIFICATION]}
                        >
                            <NotificationDetails />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="notification-update"
                            exact
                            path="/notifications/:id/update"
                            pageName="Update Notification"
                            permissions={[PERMISSION.UPDATE_MANUAL_NOTIFICATION]}
                        >
                            <NotificationUpdate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="seotag"
                            exact
                            path="/seo_tags"
                            pageName="Seo Tags"
                            permissions={[PERMISSION.VIEW_SEO_TAG]}
                        >
                            <SeoTagList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="seotag-create"
                            exact
                            path="/seo_tags/create"
                            pageName="Add Seo Tag"
                            permissions={[PERMISSION.CREATE_SEO_TAG]}
                        >
                            <SeoTagCreate />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="seotag"
                            exact
                            path="/seo_tags/:id"
                            pageName="Seo Tag"
                            permissions={[PERMISSION.VIEW_SEO_TAG]}
                        >
                            <SeoTagShow />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="seotag-edit"
                            exact
                            path="/seo_tags/:id/edit"
                            pageName="Edit Seo Tag"
                            permissions={[PERMISSION.UPDATE_SEO_TAG]}
                        >
                            <SeoTagEdit />
                        </ProtectedRoute>
                        <ProtectedRoute
                            key="payment-method-channels"
                            exact
                            path="/payment_method_channels"
                            pageName="Payment Method Channels"
                            permissions={[PERMISSION.VIEW_ANY_PAYMENT_METHOD_CHANNEL]}
                        >
                            <PaymentMethodChannelPage />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment-method-channels-create"
                            exact
                            path="/payment_method_channels/create"
                            pageName="Create Payment Method Channels"
                            permissions={[PERMISSION.CREATE_PAYMENT_METHOD_CHANNEL]}
                        >
                            <PaymentMethodChannelCreate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment-method-channels-update"
                            exact
                            path="/payment_method_channels/:id/edit"
                            pageName="Edit Payment Method Channels"
                            permissions={[PERMISSION.UPDATE_PAYMENT_METHOD_CHANNEL]}
                        >
                            <PaymentMethodChannelEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="payment-method-channels-view"
                            exact
                            path="/payment_method_channels/:id"
                            pageName="View Payment Method Channels"
                            permissions={[PERMISSION.VIEW_PAYMENT_METHOD_CHANNEL]}
                        >
                            <PaymentMethodChannelShow />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="file_manager"
                            exact
                            path="/file_manager"
                            pageName="File Manager"
                            permissions={[PERMISSION.VIEW_FILE_MANAGER]}
                        >
                            <FileManager />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="sliders"
                            exact
                            path="/sliders"
                            pageName="Sliders"
                            permissions={[PERMISSION.VIEW_SLIDER]}
                        >
                            <SliderList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="sliders-view"
                            exact
                            path="/slider/:id"
                            pageName="View Slider"
                            permissions={[PERMISSION.VIEW_SLIDER]}
                        >
                            <SliderShow />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="sliders-item-create"
                            exact
                            path="/slider/:id/create"
                            pageName="Create Slider Item"
                            permissions={[PERMISSION.CREATE_SLIDER_ITEM]}
                        >
                            <SliderItemCreate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="sliders-item-edit"
                            exact
                            path="/slider_item/:id"
                            pageName="Edit Slider Item"
                            permissions={[PERMISSION.UPDATE_SLIDER_ITEM]}
                        >
                            <SliderItemEdit />
                        </ProtectedRoute>

                        <ProtectedRoute
                            exact
                            path="/blocked-countries"
                            pageName="Blocked Countries"
                            permissions={[PERMISSION.VIEW_ANY_BLOCKED_COUNTRY]}
                        >
                            <BlockedCountriesList />
                        </ProtectedRoute>
                        <ProtectedRoute
                            exact
                            path="/blocked-countries/create"
                            pageName="Add Blocked Country"
                            permissions={[PERMISSION.CREATE_BLOCKED_COUNTRY]}
                        >
                            <BlockedCountyCreate />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="missing-translations-articles"
                            exact
                            path="/missing-translations/articles"
                            pageName="Missing translations of articles"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <MissingTranslationsArticlesList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="missing-translations-partials"
                            exact
                            path="/missing-translations/partials"
                            pageName="Missing translation of system pagess"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <MissingTranslationsArticlesList partials />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="missing-translations-articles"
                            exact
                            path="/missing-translations/articles"
                            pageName="Missing translations of articles"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <MissingTranslationsArticlesList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="missing-translations-partials"
                            exact
                            path="/missing-translations/partials"
                            pageName="Missing translation of system pagess"
                            permissions={[PERMISSION.VIEW_ARTICLE]}
                        >
                            <MissingTranslationsArticlesList partials />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="custom-redirects"
                            exact
                            path="/custom-redirects"
                            pageName="Custom redirects"
                            permissions={[PERMISSION.VIEW_CUSTOM_REDIRECT]}
                        >
                            <CustomRedirectsList />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="custom-redirect-create"
                            exact
                            path="/custom-redirects/create/"
                            pageName="Create a custom redirect"
                            permissions={[PERMISSION.CREATE_CUSTOM_REDIRECT]}
                        >
                            <CreateCustomRedirect />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="custom-redirect-edit"
                            exact
                            path="/custom-redirects/:id/edit"
                            pageName="Edit a custom redirect"
                            permissions={[PERMISSION.UPDATE_CUSTOM_REDIRECT]}
                        >
                            <EditCustomRedirect />
                        </ProtectedRoute>

                        <ProtectedRoute
                            key="custom-redirects-show"
                            exact
                            path="/custom-redirects/:id"
                            pageName="Show a custom article"
                            permissions={[PERMISSION.VIEW_CUSTOM_REDIRECT]}
                        >
                            <SingleCustomRedirect />
                        </ProtectedRoute>
                        {IS_CASINO_ENABLED && <CasinoRootComponent />}
                    </Switch>
                </>
            )}
        </>
    );
}
